import classNames from 'classnames';
import * as React from 'react';
import { Link } from 'react-router-dom';
import ContactIcon from '@css-xp/base/assets/img/icon-avatar.svg';
import { CONTACT_PATH } from '@atlassian/cssxp-typescommon';
import { BillingAdmin, Maybe, TransactionAccount } from '@css-xp/graphtypes';
import { ColGroup, SearchResultsTable, TableHead, SimpleTD, navigateTo, InfoPanel } from '@css-xp/base';
import { BillingAdminErrorMessage } from '@atlassian/cssxp-types-billing';

interface Props {
  transactionAccount: Maybe<TransactionAccount>;
}

const columns = [
  {
    name: 'Name',
    customClassNames: 'col-15',
  },
  {
    name: 'Email',
    customClassNames: 'col-15',
  },
  {
    name: '',
    customClassNames: 'col-auto',
  },
];

// Currently pulls every billing admin, will want to move

const TransactionAccountBillingAdminsTable = ({ transactionAccount }: Props) => {
  const billingAdminsConnection = transactionAccount?.billingAdmins;
  const hasNoResults = billingAdminsConnection?.nodes?.length === 0;

  return (
    <>
      {hasNoResults && <InfoPanel type="error" message={BillingAdminErrorMessage.NO_RESULTS} />}
      <SearchResultsTable
        id="transaction-account-billing-admins"
        isLoading={false}
        error={null}
        noResults={hasNoResults}
        heading={'Billing admins'}
        entityName="billing admins"
      >
        <ColGroup columns={columns} />
        <TableHead columns={columns} />

        {(billingAdminsConnection?.nodes ?? []).map((contact: Maybe<BillingAdmin>, index: number) => {
          return (
            <tbody
              key={`statuspage-people-${index}`}
              data-testid="statuspage-billing-contacts"
              onClick={() => navigateTo(`${CONTACT_PATH}/${encodeURIComponent(contact?.email ?? '')}`)}
            >
              <tr className={classNames('search-result')}>
                <td title={contact?.fullName || undefined} className="contact-name">
                  <Link
                    to={`${CONTACT_PATH}/${encodeURIComponent(contact?.email ?? '')}`}
                    onClick={(e) => e.stopPropagation()}
                    className="avatar-container"
                  >
                    {/*// @ts-ignore */}
                    <img src={ContactIcon} className="avatar medium" />
                    {contact?.fullName ?? contact?.email}
                  </Link>
                </td>
                <SimpleTD text={contact?.email} className={'contact-email'} />
                <td />
              </tr>
            </tbody>
          );
        })}
      </SearchResultsTable>
    </>
  );
};

export default TransactionAccountBillingAdminsTable;
